<template>
    <div class="w-100 mt-3">
        <label
            for=""
            class="font-14 mt-2"
        >
            Ponto focal da imagem
        </label>

        <div class="d-flex flex-column">
            <div @click.stop.prevent="setPoint($event)" style="width: fit-content" class="position-relative">
                <base-image
                    :customClass="'img-fluid rounded pointer'"
                    :source="url"
                    :fitIn="'0x300'"
                />

                <i
                    class="fal fa-square crosshairs"
                    :style="iconPosition"
                >
                </i>
            </div>
        </div>
    </div>
</template>

<script>
import BaseImage from './BaseImage.vue'

export default {
    name: 'SettingFrameBackgroundImageFocalPoint',
    data() {
        return {
            focalPoint: null,
        }
    },
    props: {
        url: {
            type: String,
        },
        initialPosition: {
            type: Object,
            default: () => {
                return {
                    x: 50,
                    y: 50,
                };
            },
        },
    },
    components: {
        BaseImage,
    },
    methods: {
        setPoint(event) {
            // pegando a posição do click dentro da imagem
            const clickInX = event.offsetX;
            const clickInY = event.offsetY;

            // pegando a largura e altura da imagem
            const xOrigin = event.target.clientWidth;
            const yOrigin = event.target.clientHeight;

            // calculando a porcentagem do click em relação a imagem
            this.focalPoint = {
                'x': Math.round((clickInX / xOrigin).toFixed(2) * 100),
                'y': Math.round((clickInY / yOrigin).toFixed(2) * 100)
            }
            
            // emitindo o evento para o pai
            this.$emit('onChangeBackgroundImageFocalPoint',
                this.focalPoint
            );
        },
    },
    computed: {
        // calculando a posição do ícone
        iconPosition() {
            // sempre que o focalPoint mudar, o ícone também muda de posição
            const focalPoint = this.focalPoint;
            const x = focalPoint ? focalPoint.x : 50;
            const y = focalPoint ? focalPoint.y : 50;

            // retorna em style a posição do ícone
            return {
                left: `${x}%`,
                top: `${y}%`,
            };
        },
    },
    created() {
        // define o valor inicial do focalPoint (necessario quando o frame ainda não possui extra)
        this.focalPoint = this.initialPosition;
    },
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameBackgroundImageFocalPoint.vue